<script lang="ts">
  import {
    deleteUserData,
    updateAnswerForUser,
    updateName,
  } from "../services/cleanup";

  import { readable_question } from "../utils/readable_question";

  export let firstRowInBlock;
  export let finalRowInBlock;
  export let rowsInBlock;
  export let item;
  export let user;
  export let updated = null;
  let error = false;
  export let replacement = "";
  export let projectId;

  // console.log(user, item);

  // const update = async () => {
  //   const result = await updateName(projectId, data.id, replacement);
  //   // if (result && result.success) {
  //   //   data.name = replacement;
  //   //   replacement = "";
  //   // }
  // };

  const globalUpdate = async () => {
    error = false;
    if (replacement === "") {
      error = true;
      return;
    }
    const result = await updateName(projectId, item.answer.id, replacement);
    if (result && result.success) {
      item.answer.data = replacement;
      replacement = "";
      if (updated) {
        updated();
      }
    }
  };

  const update = async () => {
    error = false;
    if (replacement === "") {
      error = true;
      return;
    }
    item.allAnswers[item.indexForQuestion] = replacement;
    const answers = item.allAnswers.map((a) => {
      if (typeof a == "object") {
        return a.data;
      }
      return a;
    });
    const result = await updateAnswerForUser(
      projectId,
      user,
      answers,
      item.identifier
    );
    if (result && result.success) {
      item.answer.data = replacement;
      replacement = "";
      if (updated) {
        updated();
      }
    }
  };

  const del = async () => {
    const result = await deleteUserData(projectId, user);
    if (result && result.success) {
      if (updated) {
        updated();
      }
    }
  };
</script>

<tr class:is-tight={!finalRowInBlock}>
  <td class="is-narrow">
    {readable_question(item.identifier)}
  </td>
  <td>
    {item.answer.data}
  </td>
  <td><input class:has-error={error} bind:value={replacement} type="text" /></td
  >
  <td class="remove-padding"
    ><button class="btn" on:click={update}>update</button></td
  >
  <td class="is-danger"
    ><button class="btn" on:click={globalUpdate}>global update</button></td
  >
  {#if firstRowInBlock}
    <td rowspan={rowsInBlock} class="is-danger is-stretched"
      ><button class="btn" on:click={del}>delete user</button></td
    >{/if}
</tr>

<style lang="scss">
  button {
    line-height: 18px;
    font-weight: normal;
  }

  .is-danger button {
    width: 140px;
  }
  td.is-danger {
    width: 148px;
  }

  tr.is-tight td.is-danger {
    border-color: #fc72cd;
    border-bottom: none;
  }

  td.is-stretched {
    border-bottom-width: 4px !important;
    border-bottom-style: solid !important;
    border-color: #d4d3bc !important;
  }

  td.is-danger:not(:last-child) {
    border-right-width: 0;
    padding-right: 0;
    width: 144px;
  }
  td.is-danger:last-child {
    // padding-left: 0;
    text-align: right;
  }
  button {
    line-height: 18px;
    font-weight: normal;
  }
  th.is-danger {
    width: 160px;
  }
  input.has-error {
    border: 1px solid red;
  }
</style>
